var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":"","disable-resize-watcher":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('TheNavigationHeader'),_c('v-divider'),_c('TheNavigationList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }